

import { Component, Vue } from "vue-property-decorator"
import { Getter, Action } from "vuex-class"

import api from "@/services/api"

import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"
import { UserSettings } from "@/types/userSettings"
import { User } from "@/types"
import apiUserStatus from "@/services/api_UserStatus"
import { UserStatus } from "@/types/userStatus"

@Component({
	components: {
		"userSettingsModal": BModal,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class SetStatusModal extends Vue {
	@Getter("getMe") public me!: User;

	@Action setCurrentUserStatus!: (userStatus: UserStatus) => void
	@Action clearCurrentUserStatus!: () => void

	private isOpen: boolean = false;

	private selectedStatusId: string = "";

	private statuses: UserStatus[] = []

	private async statusChanged (newStatusId: string) {
		const newStatus = this.statuses.find(c => c.id === newStatusId)!
		this.setCurrentUserStatus(newStatus)
		this.selectedStatusId = newStatusId
	}

	private clearStatusEnabled () : boolean {
		return !!this.selectedStatusId
	}

	public async open () {
		this.isOpen = true
		this.statuses = await apiUserStatus.userStatusList()
		if (this.me.currentStatus) {
			this.selectedStatusId = this.me.currentStatus.id!
		}
	}

	private clearStatus () {
		this.clearCurrentUserStatus()
		this.selectedStatusId = ""
	}
}
